export const AuthEndpoint = {
  Login: `${process.env.REACT_APP_API_URL}auth/login`,
  Logout: `${process.env.REACT_APP_API_URL}auth/logout`,
  Refresh: `${process.env.REACT_APP_API_URL}auth/refresh`,
  // switch back to
  // "https://api-dev-pliva.kipich.com/api/auth/refresh",
};
